import { useMutation } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

// Prepares the reply behind the button. It issues the link and renders the
// message, but sends nothing — the body goes into the composer and a person
// presses send.
export const useRescheduleLink = conversationId => {
  const { mutateAsync: prepareRescheduleLink, ...rest } = useMutation({
    mutationFn: async appointmentId => {
      const res = await fetch(
        `${baseURL}/v2/rest/conversations/${conversationId}/reschedule_link`,
        {
          method: 'POST',
          headers,
          body: JSON.stringify(
            appointmentId ? { rescheduleLink: { appointmentId } } : {}
          ),
        }
      )

      const data = await res.json().catch(() => null)

      if (res.ok) return data

      // Every refusal the button can act on is a 422 carrying a `reason`. The
      // rest — a 404 for a record out of reach, a 401 keyed `error` instead of
      // `errors` — has no reason to branch on and only its sentence to show.
      const error = new Error(
        (typeof data?.errors === 'string' && data.errors) ||
          (typeof data?.error === 'string' && data.error) ||
          "We couldn't prepare a reschedule link"
      )

      error.reason = data?.reason
      error.appointments = data?.appointments || []

      throw error
    },
  })

  return { prepareRescheduleLink, ...rest }
}
